import React, { Component } from "react";
import { connect } from "react-redux";
import TestRunStatusTableCloseLoopRevised from "../components/closedLoop/TestRunStatusTableCloseLoopRevised"
// import PaginationCloseLoopRevised from "../components/closedLoop/PaginationCloseLoopRevised";
import AdvanceSearchModalCloseLoopRevised from "../components/closedLoop/AdvanceSearchModalCloseLoopRevised"
import { getNewTestRunStatusInfoCloseLoop, getTotalScenarioGroupsSummary } from "../components/UserFunctions"
// import { addTestRunStatusFromAPI } from "../actions/closeLoop/testRunStatusActionCloseLoop"
// import ReactPaginate from 'react-paginate';
import PropTypes from 'prop-types';
import Pagination from './../components/Pagination'
import { getTestRunStatusFromAPI } from "../actions/closeLoop/testRunStatusRevisedActionCloseLoop"

class TestRunStatusCloseLoopRevised extends Component {
    constructor(props) {
        super(props)
        this.state = {
            view_filter: false,
            runid: [],
            version_id: [], 
            result: [],
            total_scenario_groups: [],
            total_runs: [],
            no_of_benches: [],
            result_status: [],
            scene_group_id: [],
            offset: 0,
            tableData: [],
            orgtableData: [],
            perPage: 5000,
            currentPage: 0,
        }
    }

    handleViewReportClick = (e,row,data,sceneData) => {
        const url = `/AutomateKPI/4?tagid=${data['tag_name']}&benchid=${data['bench_id']}&benchname=${data['bench_name']}&scenariogroup=${row['scenario_group_id']}&runid=${data['test_run_id']}&sceneid=${row['scenario_uuid']}`
        this.props.history.push(url)
      }

    onFilterClick() {
        this.setState({
            view_filter: true
        })
    }
    onCloseFilter() {
        this.setState({
            view_filter: false
        })
    }

    onSearchClick = ( runid, version_id,bench_names,cad_id,status,run_id_null_filter) => {
        // console.log(runid, version_id,bench_names,cad_id,status,run_id_null_filter)
        this.setState({
            view_filter: false,
            status:status,
            cad_id:cad_id,
            bench_names: bench_names,
            //result: result,
            runid: runid,
            version_id: version_id,
            //video_availability: video_availability,
        })
        var run_id_null_filter_string;
        if (run_id_null_filter === true)
        {
            run_id_null_filter_string = "true"
        }
        else
        {
            run_id_null_filter_string  = "false"
        }
        var json_obj = { 'status':status,'cad_id':cad_id,'bench': bench_names,  'date': [], 'runid': runid, 'version': version_id, 'run_id_null_filter':run_id_null_filter_string }
        console.log("json object-->",json_obj)

        getNewTestRunStatusInfoCloseLoop(1, json_obj).then(response => {            
            //console.log(response.data)
            var data = response.data;
            var slice = data.slice(this.state.offset, this.state.offset + this.state.perPage)
            if(response.data){
                this.props.dispatch(getTestRunStatusFromAPI(response))
                this.setState({
                    pageCount: Math.ceil(data.length / this.state.perPage),
                    orgtableData: response.data,
                    tableData: slice
                })
            } else {
                this.props.dispatch(getTestRunStatusFromAPI([]))
            }
        })
    }
    onResetClick = () => {
        this.setState({
            //view_filter: false,
            status:[],
            cad_id:[],
            bench_names: [],
            //result: result,
            runid: [],
            version_id: [],
            //video_availability: video_availability,
        })


        getNewTestRunStatusInfoCloseLoop(1).then(response => {
            var data = response.data;
            var slice = data.slice(this.state.offset, this.state.offset + this.state.perPage)
            if(response.data){
                this.props.dispatch(getTestRunStatusFromAPI(response))
                this.setState({
                    pageCount: Math.ceil(data.length / this.state.perPage),
                    orgtableData: response.data,
                    tableData: slice
                })
            } else {
                this.props.dispatch(getTestRunStatusFromAPI([]))
            }
        })
        // console.log("Called:",this.state)
        
}

    onChangeHandler = (event) => {
        this.setState({
            scene_group_id: event.target.value
        })
    }

    handlePageClik = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage * this.state.perPage;
        this.setState({
            currentPage: selectedPage,
            offset: offset
        }, () => {
            this.loadMoreData()
        })
    }

    loadMoreData() {
        const data = this.state.orgtableData;

        const slice = data.slice(this.state.offset, this.state.offset + this.state.perPage)
        this.setState({
            pageCount: Math.ceil(data.length / this.state.perPage),
            tableData: slice
        })
    }
    

    
   
    componentDidMount() {
        getNewTestRunStatusInfoCloseLoop(1).then(response => {
            var data = response.data;
            console.log("this is data : ", data)
            var slice = data.slice(this.state.offset, this.state.offset + this.state.perPage)
            if(response.data){
                this.props.dispatch(getTestRunStatusFromAPI(response))
                this.setState({
                    pageCount: Math.ceil(data.length / this.state.perPage),
                    orgtableData: response.data,
                    tableData: slice
                })
            } else {
                this.props.dispatch(getTestRunStatusFromAPI([]))
            }
            

           
        });

        getTotalScenarioGroupsSummary().then(response => {

            this.setState({
                total_scenario_groups: response.data.total_scenario_groups,
                total_scenarios: response.data.total_scenarios,
                total_runs: response.data.total_runs,
                no_of_benches: response.data.no_of_benches,
                result_status: response.data.result
            })
        })
    }

    


    render() {
        return (
            <div className="container-fluid">
                <div className="card">
                    <h1 className="card-header" style={{color: "white", backgroundColor: "#757AF7" }}>Run Status </h1>
                
                <div className="row" style={{margin: "0px" }}>
                    <div className="mt-2 mx-auto">
                        <div className="row">
                            <div className="col-lg-2" >
                                <div className="card" style={{ border: "2px solid #858AFF", margin: "5px"  }}>
                                    <div className="card-header" style={{ borderBottom: "2px solid #858AFF", backgroundColor: "#B0FF44" }}>
                                        No. of Benches:
                                    </div>
                                    <div style={{ textAlign: "center", fontSize: "2rem", color: "#8B8B8B" }}>
                                        {this.state.no_of_benches}
                                    </div>
                                </div>
                                <div className="card" style={{ border: "2px solid #858AFF", margin: "5px" }}>
                                    <div className="card-header" style={{ borderBottom: "2px solid #858AFF", backgroundColor: "#B0FF44" }}>
                                        Total Test Runs:
                                    </div>
                                    <div style={{ textAlign: "center", fontSize: "2rem", color: "#8B8B8B" }}>
                                        {this.state.total_runs}
                                    </div>
                                </div>
                                <div className="card" style={{border: "2px solid #858AFF", margin: "5px" }}>
                                    <div className="card-header" style={{ borderBottom: "2px solid #858AFF", backgroundColor: "#B0FF44" }}>
                                        Total Scenario Groups:
                                    </div>
                                    <div style={{ textAlign: "center", fontSize: "2rem", color: "#8B8B8B" }}>
                                        {this.state.total_scenario_groups}
                                    </div>
                                </div>
                                <div className="card" style={{border: "2px solid #858AFF", margin: "5px" }}>
                                    <div className="card-header" style={{ borderBottom: "2px solid #858AFF", backgroundColor: "#B0FF44" }}>
                                        Total Scenarios:
                                    </div>
                                    <div style={{ textAlign: "center", fontSize: "2rem", color: "#8B8B8B" }}>
                                        {this.state.total_scenarios}
                                    </div>
                                </div>

                                
                                
                            </div>
                            <div className="col-lg-10" style={{ paddingLeft: "0px", paddingTop: "5px" }}>
                                <div className = "row" style={{  backgroundColor: "#757AF7",marginRight:"0rem" }}>
                                <div style={{ border: "1px solid #858AFF", backgroundColor: "#757AF7" }}>
                                    <div style={{ display: "inline-block" }}>
                                        <button type="button" className="btn" onClick={() => this.onFilterClick()} style={{ cursor: "pointer", color: "#212121", backgroundColor: "#B0FF44" }} >
                                            <i className="fa fa-filter" aria-hidden="true"></i>
                                            Filter
                                        </button>
                                    </div>
                                    
                                    <div style={{ display: "inline-block", width: "50rem" }}>
                                        <div style={{ padding: "5px", color: "#FFFFFF", fontWeight: "bold", display: "inline-block" }}>
                                            Applied Filter :
                                        </div>
                                        {/* <input type="text" disabled={true} style={{ backgroundColor: "#FFFFFF" }} /> */}
                                        {(this.state.bench_names === undefined ) || (this.state.bench_names.length  <= 0 && this.state.runid.length <= 0 && this.state.version_id.length <= 0 && this.state.cad_id.length <= 0 && this.state.status.length <= 0) ?
                                            <div style={{ display: "inline-block", backgroundColor: "#f2f2f2", width: "30rem", color: "#464646" }}>
                                                No Filters Applied
                                            </div> :
                                                <div style={{display:"inline-block"}}>
                                                    <div  style={{backgroundColor: "#f2f2f2", width: "30rem",height:"1.8rem", color: "red",display:"inline-block"}}>
                                                    {this.state.bench_names} {this.state.runid} {this.state.version_id} {this.state.cad_id} {this.state.status}                                              
                                                    
                                                </div>
                                                <td  style={{display:"inline-block"}}><button type = "button" onClick={this.onResetClick} ><i class = "fa fa-undo"></i></button></td>
                                            </div>
                                            }

                                        </div>  
                                    </div>
                                </div>
                                <div style={{ padding: "0px", display: "inline-block" }}>
                                    {/* <div className="table col-md-6 mx-auto" style={{ padding: "0px" }}> */}
                                    <div className="table" style={{ padding: "0px" }}>  
                                        <TestRunStatusTableCloseLoopRevised testRunStatus={this.props.testData} onViewReportClick={this.handleViewReportClick}/>
                                    </div>
                                </div>
                                </div>
                                <div style={{ padding: "0rem 20rem" }}>
                                    
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                {this.state.view_filter ? <AdvanceSearchModalCloseLoopRevised closeSearchModal={this.onCloseFilter.bind(this)} onSearchClick={this.onSearchClick} /> : ""}
                <div>
                    {this.props.testData.length > 0 ?
                    <Pagination
                    currentPage={this.props.currentPageRevised}
                    pages={this.props.pagesRevised}
                    getApiInfo={getNewTestRunStatusInfoCloseLoop}
                    action={getTestRunStatusFromAPI}
                    />
                    : undefined}
                    </div>
            </div>
        )
    }
}
TestRunStatusCloseLoopRevised.propTypes={
history:PropTypes.string,
}
TestRunStatusCloseLoopRevised.defaultProps= {
history:[],
}
const mapStateToProps = (state) => {
    return {
        // testRunStatus: state.testRunStatus_close_loop.testRunStatus,
        // currentPage: state.testRunStatus_close_loop.currentPage,
        // pages: state.testRunStatus_close_loop.pages,
        
        testData: state.testRunStatusRevisedCloseLoop.testData,
        currentPageRevised: state.testRunStatusRevisedCloseLoop.currentPage,
        pagesRevised: state.testRunStatusRevisedCloseLoop.pages

    }
}

export default connect(mapStateToProps)(TestRunStatusCloseLoopRevised);
